import { DataSource } from '@angular/cdk/table';
import { Component, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { AuthenticationService } from '@app/_services';
import { QuotationCartService } from '@app/_services/quotation.service';
import { ToastrService } from 'ngx-toastr';
import { Interface } from 'readline';
import * as _ from 'lodash';
import { json } from 'body-parser';
import { Router, RouterLink } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import { MatDividerModule } from '@angular/material/divider';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { InputNumberComponent } from '../../../../../shared/components/input-number/input-number.component';
import { BookingDetailsViewerComponent } from '../../../../../shared/components/booking-details/booking-details.component';
import { OptionsDetailsViewerComponent } from '../../../../../shared/components/options-details/options-details.component';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-quotation-vendorContainer',
    templateUrl: './quotation-vendor.component.html',
    styleUrls: ['./quotation-vendor.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, FlexModule, NgFor, RouterLink, OptionsDetailsViewerComponent, BookingDetailsViewerComponent, InputNumberComponent, FormsModule, ReactiveFormsModule, ExtendedModule, MatDividerModule, TranslateModule]
})
export class VendorQuotationComponent {
    loading: boolean;
    updating: boolean;
    constructor(
        private authService: AuthenticationService,
        public quotationCart: QuotationCartService,
        private toastr: ToastrService,
        private router: Router,
        public translate: TranslateService,
        public translateHelper: TranslateHelper
    ) { }

    userDetails;

    items;

    @Input() cart;

    form: UntypedFormArray;

    displayedColumns: string[] = [
        'item',
        'item details',
        'product code',
        'quantity',
    ];
    columnsToDisplay: string[] = this.displayedColumns.slice();

    ngOnInit(): void {
        this.authService.currentUser.subscribe((user): any => {
            this.userDetails = user;
        });

        this.items = [];
        this.form = new UntypedFormArray([]);
        if (this.cart?.items instanceof Array) {
            this.cart.items.forEach((element) => {
                let filteredOptions = [];
                _.forEach(element.options, option => {
                    if (option.valueId) filteredOptions.push(option);
                    if (option.value) filteredOptions.push(option);
                });
                this.items.push({
                    item: element.product?.name?.[this.translate.currentLang],
                    item_details: element.product?.description?.[this.translate.currentLang],
                    code: element.product?.code,
                    quantity: new UntypedFormControl(+element.amount),
                    itemId: element.itemId,
                    image:
                        element.product.images[
                            _.findKey(element.product.images)
                        ]?.url,
                    options: filteredOptions,
                    serviceData: element.serviceData,
                    minQuantity:element.product?.minQuotationAmount
                });
            });
        }
    }

    updateValue(quantity, itemId) {
        this.loading = true;
        let params: any = {};
        params = {
            itemId: itemId,
            amount: quantity,
        };
        this.quotationCart.updateCartItem(params).subscribe(
            (response) => {
                this.loading = false;
            },
            (error) => {
                this.toastr.error(error?.error?.msg);
                this.loading = false;
            }
        );
    }

    submit(cartId) {
        this.loading = true;
        this.quotationCart.submit(cartId, this.userDetails.userId).subscribe(
            (response) => {
                this.loading = false;
                if (response) {
                    this.toastr.success(response.msg);
                    if (!this.quotationCart.quantity) {
                        this.router.navigate(['/account/active-quotations']);
                    }
                }
            },
            (error) => {
                this.toastr.error(error?.error?.msg);
                this.loading = false;
            }
        );
    }

}
